import { dataShieldCheck } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldCheck = /*#__PURE__*/createIcon(dataShieldCheck)
export default IconShieldCheck
